import { render } from "./TaskPlatforms.vue?vue&type=template&id=4d47a59e"
import script from "./TaskPlatforms.vue?vue&type=script&lang=js"
export * from "./TaskPlatforms.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__